<h1 mat-dialog-title></h1>
<div mat-dialog-content>
    <div class="flex flex-column align-center">
        <mat-icon [color]="success ? 'primary' : 'warn'">{{ success ? 'check_circle' : 'warning'}}</mat-icon>
        <h1>
            {{ 
                (onlyMsg)
                ? (onlyMsgTitle ? onlyMsgTitle : 'Atenção')
                : success ? 'Pagamento efetuado com sucesso' : 'Falha ao efetuar pagamento' 
            }}
        </h1>
        <div *ngIf="!success" class="w-100 center" [innerHTML]="msg | safeHtml"></div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="close()" color="primary">Ok</button>
</div>
